<form style="margin: 0px 0px 30px 0px;" name="preCheckoutCelular" *ngIf="display.enableCelular" class="needs-validation" [formGroup]="preCheckoutFormCelular" (ngSubmit)="onSubmit()" novalidate>
    <label [class.label-invalid]="!validFormCelular()" translate>Celular</label>
    <div class="d-flex align-items-center input-group has-validations">
        <input class="form-control" aria-describedby="basic-celular" (blur)="alterarTelefone()" type="text" placeholder=" " formControlName="telefone" id="telefone" mask="(00)00000-0000" 
        [class.input-invalid]="!validPhone()" required/>
        
        <div class="input-group-append">
            <span class="input-group-text" id="basic-celular">
                <fa-icon class="float-end" [icon]="['fas', 'mobile-alt']" size="lg"></fa-icon>
            </span>
        </div>
        <div *ngIf="!validPhone()" class="error" translate>
            O Celular informado é inválido
        </div>
    </div>

    <div class="container" *ngIf="podeAtualizarTelefone() && validFormCelular()">
        <div class="row">
          <div class="col-sm" style="padding: 0 !important;">
            <div class="pb col next-button">
                <button type="submit" class="btn btn-primary">
                    Atualizar celular &nbsp;
                    <fa-icon class="float-end" [icon]="['fas', 'sync-alt']" size="lg"></fa-icon>
                </button>
            </div>
          </div>
        </div>
    </div>

    <div class="container" *ngIf="!podeAtualizarTelefone() && validFormCelular()">
        <div class="row">
          <div class="col-sm" style="padding: 0 !important;">
            <div class="pb col next-button">
                <button type="button" class="btn btn-primary">
                    PROSSEGUIR &nbsp;
                    <fa-icon class="float-end" [icon]="['fas', 'arrow-circle-right']" size="lg"></fa-icon>
                </button>
            </div>
          </div>
        </div>
    </div>

</form>

<app-pre-checkout-login-sms *ngIf="display.enableSMS"></app-pre-checkout-login-sms>
<app-pre-checkout-login-info *ngIf="display.enableInfo" [statusMotorista]="statusMotorista"></app-pre-checkout-login-info>

<div class="container" *ngIf="!display.enableCelular && !display.enableSMS && !display.enableInfo">
    <div class="row">
      <div class="col-sm" style="padding: 0 !important;">
        <div class="pb col next-button">
            <button type="button" class="btn btn-primary" (click)="prosseguir()">
                PROSSEGUIR &nbsp;
                <fa-icon class="float-end" [icon]="['fas', 'arrow-circle-right']" size="lg"></fa-icon>
            </button>
        </div>
      </div>
    </div>
</div>

<app-modal #modalAlterarTelefone [(modalConfig)]="modalConfig">
    <span style="color: red;">Número de celular divergente com o seu cadastro, deseja atualizar com esse número?<br/>
    Só atualize se esse número for seu.</span>
</app-modal>